export const PAGE_FIX_FORM_VIEW_NAME = {
    INFO: 'info-view',
    OPTIONS: 'options-view',
    TESTING: 'testing-view',
} as const;
